import { Injectable } from '@angular/core';

/**
 * Shared service that connects `umssStickyBottomBar` (source)
 * with `umssStickyBottomBarOutlet` (destination).
 *
 * The outlet directive registers its native element here; the
 * sticky-bottom-bar directive reads it and appends its own host
 * element to that outlet at runtime (portal / teleport pattern).
 */
@Injectable({ providedIn: 'root' })
export class StickyBottomBarPortalService {
  private outletEl: HTMLElement | null = null;

  registerOutlet(el: HTMLElement): void {
    this.outletEl = el;
  }

  unregisterOutlet(): void {
    this.outletEl = null;
  }

  getOutlet(): HTMLElement | null {
    return this.outletEl;
  }
}
